import React from 'react';
import { IconPDFAttachment } from 'jitsi/base/icons/svg';
import { AttachmentIcon } from './components/AttachmentIcon';
import { Container } from './components/Container';
import { Details } from './components/Details';
export const PDF = ({ name, ...containerProps }) => {
    return (React.createElement(Container, { ...containerProps },
        React.createElement(AttachmentIcon, { icon: IconPDFAttachment, color: 'iisightBlue500' }),
        React.createElement(Details, { title: name, description: 'PDF' })));
};
